/**
 * Version 0.115
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2018.
 *
 * !Changelog
 *
 * 2023
 * 	27-03-2023
 * 	- [CHANGE] The mobile Fix: 100% Height mobile was not good enough, it's better now.
 * 2018
 * 	08-03-2019
 * 	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
 * 	11-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_window = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.lastScrollTop = 0;
	this.subtitleHidden = false;

	// this.onready = function () {
	// };

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/**
	 * Window: resize
	 */
	this.windowResize = function (scrolled, h, w) {

		/**
		 * Set: Variables
		 */
		if (typeof h === 'undefined') {
			h = $(window).height();
		}
		if (typeof w === 'undefined') {
			w = $(window).width();
		}

		/**
		 * Fix: 100% Height mobile
		 */
		document.querySelector(':root').style.setProperty('--vh', window.innerHeight + 1 + 'px'); // +1 for what?

	};

	/**
	 * Window: scroll
	 */
	this.windowScroll = function (scrolled, h, w) {

		/**
		 * Header hide/show functionality
		 */
		var currentScrollTop = $(window).scrollTop();
		var scrollDelta = Math.abs(currentScrollTop - this.lastScrollTop);

		// Only start hiding header after scrolling past 100px and with minimum scroll distance
		if (currentScrollTop > 100 && scrollDelta > 5) {
			if (currentScrollTop > this.lastScrollTop) {
				// Scrolling down - hide header
				$('header').addClass('is-hidden');
			} else {
				// Scrolling up - show header
				$('header').removeClass('is-hidden');
			}

			// Only update lastScrollTop when we actually process the scroll
			this.lastScrollTop = currentScrollTop;
		} else if (currentScrollTop <= 100) {
			// Always show header when near top
			$('header').removeClass('is-hidden');
			this.lastScrollTop = currentScrollTop;
		}

	};

	/**
	 * Window: orientation
	 */
	this.windowOrientationChange = function () {

		// none

	};

}).apply(specific_interactions_window); 
